"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeConferenceMapping = void 0;
var makeConferenceMapping = function (name) {
    return function (evt) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return ({
            event: name,
            eventInfo: name,
            action: (_a = evt === null || evt === void 0 ? void 0 : evt.eventData) === null || _a === void 0 ? void 0 : _a.action,
            conf: {
                confName: (_c = (_b = evt === null || evt === void 0 ? void 0 : evt.eventData) === null || _b === void 0 ? void 0 : _b.conf) === null || _c === void 0 ? void 0 : _c.confName,
                confCat: (_e = (_d = evt === null || evt === void 0 ? void 0 : evt.eventData) === null || _d === void 0 ? void 0 : _d.conf) === null || _e === void 0 ? void 0 : _e.confCat,
                confTags: (_g = (_f = evt === null || evt === void 0 ? void 0 : evt.eventData) === null || _f === void 0 ? void 0 : _f.conf) === null || _g === void 0 ? void 0 : _g.confTags,
                confClick: (_j = (_h = evt === null || evt === void 0 ? void 0 : evt.eventData) === null || _h === void 0 ? void 0 : _h.conf) === null || _j === void 0 ? void 0 : _j.confClick,
            },
        });
    };
};
exports.makeConferenceMapping = makeConferenceMapping;
